export default __webpack_public_path__ + "static/media/15-color.2f903fc9.svg";